export default class TextInput extends React.Component {
  constructor(props) {
    super();
    this.state = {
      value: props.value || '',
      focused: false
    };
  }

  render() {
    const { placeholder, required, name, field } = this.props
    const { value, focused } = this.state
    const classes = classNames({
      'show-labelholder': value,
      'focused': focused,
    }, 'labelholder')
    return (
      <div className={classes}
           data-label={placeholder || ''}>
        <input type="text"
               required={required && JSON.parse(required)}
               className={`form-control ${value ? 'has-value': ''}`}
               value={value || ''}
               onChange={this._input.bind(this)}
               onFocus={() => this.setState({focused: true})}
               onBlur={() => this.setState({focused: false})}
               name={name}
               placeholder={placeholder || ''}
               id={field}/>
        <div className="remover" onClick={this._clear.bind(this)}></div>
      </div>
    );
  }

  _input(e) {
    this.setState({value: e.target.value})
  }

  _clear() {
    this.setState({value: null})
  }
}

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  required: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ])
};

